import React from 'react'
import { AddDropdown } from '../../../commonComponents/dropdown/AddDropdown'
import {  useSelector } from 'react-redux'

const UNDG=({lineItemIndex, invoiceId,merchandiseId,updateData,onChange,boxNumber})=>{
 
  const undg =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.undg) || ''
  const undgId =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.undgId) 
  return (
   <AddDropdown
              id={`undg-${invoiceId}-${merchandiseId}`}
              type='UNDG'
              label='UNDG'
              boxNumber={boxNumber}
              onSelect={({ value }) => {
                updateData({undg:value})
                onChange("undgId",{undg: value,undgId})
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({undg:value})
                  onChange("undgId",{undg: value || " ",undgId})
                }
              }}
              selectedValue={undg}
            />
            
  )
}
export default UNDG
